import loadRenderer from "../renderer/loadRenderer";
import curry from "../lib/core/functional/curry";

const prepareModuleLoader = curry(function prepareModuleLoader(
    renderer,
    context,
    dependencies,
    moduleLoader,
    altLoader
) {
    return moduleLoader()
        .then((mod) => mod(renderer))
        .then((moduleGetter) => moduleGetter(context, dependencies, altLoader));
});

export default function preactLoader(
    externalModuleName,
    context,
    dependencies,
    internalModuleLoader
) {
    const externalModuleLoader =
        externalModuleName in window.RM_OVERRIDES ? window.RM_OVERRIDES[externalModuleName] : null;

    const getModule = externalModuleLoader || internalModuleLoader;

    return loadRenderer().then((renderer) => {
        const loader = prepareModuleLoader(renderer, context, dependencies);
        const altModule = externalModuleLoader ? () => loader(internalModuleLoader, null) : null;
        return loader(getModule, altModule).then((mainModule) => [renderer, mainModule]);
    });
}
